// @flow
import InformsStandart from './InformsStandart';

export default InformsStandart;
